import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

export default function NavbarNavItem({
  href,
  label,
  icon,
  isActive,
  onClick,
  activeColor,
}) {
  return (
    <ListItem disablePadding>
      <ListItemButton
        selected={isActive}
        onClick={() => onClick(href)}
        sx={{
          borderRadius: 2,
          px: 2.25,
          py: 1,
          columnGap: 1.4,
          transition: "all .18s ease",
          "&.Mui-selected": {
            backgroundColor: "rgba(99,102,241,0.12)",
            color: activeColor,
          },
        }}
      >
        <ListItemIcon
          sx={{
            minWidth: 24,
            color: isActive ? activeColor : "#a0aec0",
            display: "flex",
            alignItems: "center",
          }}
        >
          {icon}
        </ListItemIcon>
        <ListItemText
          primary={label}
          primaryTypographyProps={{
            fontWeight: isActive ? 600 : 500,
            color: isActive ? activeColor : "#475569",
            fontSize: "0.9rem",
            lineHeight: 1.25,
          }}
        />
      </ListItemButton>
    </ListItem>
  );
}
